<template>
  <nav
    v-if="show"
    class="header-breadcrumbs"
    :aria-label="'Breadcrumbs'"
  >
    <div class="wrap">
      <ul>
        <li
          v-for="(breadcrumb, index) in breadcrumbs"
          :key="index"
        >
          <a
            v-if="breadcrumb.href"
            :href="breadcrumb.href"
          >
            {{ breadcrumb.label }}
          </a>
          <span v-else>{{ breadcrumb.label }}</span>
        </li>
      </ul>
    </div>

    <component
      :is="'script'"
      type="application/ld+json"
      v-html="jsonld"
    />
  </nav>
</template>

<script>
  import CookieUtils from 'utils/CookieUtils'
  export default {
    props: {
      breadcrumbs: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        show: false
      }
    },
    computed: {
      jsonld() {
        let itemListElement = []
        let breadcrumbs = {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement
        }

        this.breadcrumbs.forEach((item, index) => {
          let data = {
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@id': window.location.origin + item.href,
              name: item.label
            }
          }

          if (index + 1 === this.breadcrumbs.length) {
            data.item['@id'] = window.location.href
          }

          itemListElement.push(data)
        })

        breadcrumbs.itemListElement = itemListElement

        return breadcrumbs
      }
    },
    created() {
      this.show = CookieUtils.getCookie('btMobileApp') ? false : true
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';

  .header-breadcrumbs {
    background-color: #ffffff;
    border-bottom: 1px solid $grey-border;
    font-family: $base-font-family;

    > .wrap {
      width: auto;
      max-width: $desktop-wide-width;

      @include bp-tablet {
        max-width: $tablet-wide-width;
      }

      @include bp-desktop-small {
        padding: 0 26px;
      }
    }

    ul {
      height: 46px;
      white-space: nowrap;
      overflow: hidden;
      overflow-x: auto;
      list-style: none;
      color: $grey;

      @include bp-tablet-only {
        padding: 0 26px;
      }
    }

    li {
      display: inline-block;
      margin-right: 14px;
      line-height: 46px;
      font-size: em(13);

      &:not(:last-child):after {
        content: $icon-arrow-right-thin;
        @include icon-font-thin();
        position: relative;
        top: 2px;
        margin-left: 14px;
        font-size: em(16);
        color: #d9d9d9;
      }
    }

    a {
      position: relative;
      border-bottom: 1px solid $green-base;
      text-decoration: none;
      color: $grey;

      @include outline-focus;

      &:hover {
        color: $grey-default;
      }
    }
  }
</style>
